import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Login from './pages/Login';

import './App.css';

const App = () => (
  <Router>
    <div className="app-layout">
  
      <div className="main-content">
        <Routes>
          <Route path="/" element={<Login />}/>
          

        </Routes>
      </div>
    </div>
  </Router>
);

export default App;
